import React, {Component} from 'react'
import {connectRefinementList, Highlight} from 'react-instantsearch-dom'
import SimpleAccordion from '../../../shared/filter-accordion'
import {getUrlParameterByName,} from '@/scripts/modules/utils'

class MenuSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      facetInputValue: ``,
      expanded: false
    }
    this.handleCheck = this.handleCheck.bind(this)
    this.onChangeDebounced = this.onChangeDebounced.bind(this)
    this.timerId = null
    this.filteredFacetDebounceDelay = 400
  }

  componentDidMount() {
    let filters = getUrlParameterByName(this.props.dropdown)
    if (filters) {
      filters = filters.split(`,`)
      this.props.refine(filters)
    }
  }

  onChangeDebounced(event) {

    const { searchForItems } = this.props
    const value = event.currentTarget.value
    const delay = this.filteredFacetDebounceDelay

    clearTimeout(this.timerId)
    this.timerId = setTimeout(() => searchForItems(value), delay)

    this.setState(() => ({
      facetInputValue: value
    }))
  }

  handleCheck(value) {
    this.props.refine(value)
    this.props.onChange && this.props.onChange(value)
    // pushNewUrl(
    //   replaceUrlParameter(window.location.href, this.props.dropdown, value)
    // );
  }


  render() {
    const {
      items,
      label,
      searchablePlaceholder,
      searchable
    } = this.props

    if (!items || !items.length) {
      return null
    }

    const { facetInputValue } = this.state

    const sortedItems = items.sort(
      (a, b) => a.label.localeCompare(b.label) || b.count - a.count
    )

    return (
        <div className="custom-checkbox filter-title-container">
          <SimpleAccordion title={label} expanded={this.state.expanded}>
          <div className="padding-1x wide">
            {searchable ? (
              <div className="facet-filter__input-wrapper">
                <input
                  value={facetInputValue}
                  className="facet-filter__input"
                  type="search"
                  placeholder={searchablePlaceholder}
                  onInput={(event) => this.onChangeDebounced(event)}
                />
              </div>
            ) : null}
            {sortedItems.map((item, index) => {
              if (
                  this.state.facetInputValue &&
                  !item.label
                      .toLowerCase()
                      .includes(
                          this.state.facetInputValue
                              .trim()
                              .toLowerCase()
                      )
              ) {
                return
              }
              const label = item._highlightResult ? (
                <Highlight
                  attribute="label"
                  hit={item}
                  tagName="strong"
                  nonHighlightedTagName="span"
                />
              ) : (
                item.label
              )
              return (
                <label
                  key={item.value + index}
                  className="container-checkbox"
                  style={{ fontWeight: item.isRefined ? `bold` : `` }}
                  onClick={event => {
                    event.preventDefault()
                    this.handleCheck(item.value)
                  }}
                >
                  {` `}
                  <span className="foreground-dark-green">
                    {label}
                    <span className="transifex-ignore">
                      &nbsp;({item.count})
                    </span>
                  </span>
                  <input
                    type="checkbox"
                    checked={item.isRefined}
                    onChange={() => {}}
                  />
                  <span className="checkmark"></span>
                </label>
              )
            })}

          </div>
        </SimpleAccordion>
        </div>
    )
  }
}

const DropdownMenuSelect = connectRefinementList(MenuSelect)

export default DropdownMenuSelect
